import { useEffect, useRef, useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import { faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const DeleteButtonMutation = ({deleteObject,confirmText = 'Click to confirm deletion',errorCallback,successCallback, size= 'sm',useDeleteHook,hookArgs = [],...props}) => {
    const [deleteConfirm, setDeleteConfirm] = useState('init');
    const containerRef = useRef();

    const delMut = useDeleteHook(...hookArgs);

    const _handleInitialClick = () => {
        setDeleteConfirm('confirm');
    }

    const _handleConfirmClick = () => {
        delMut.mutate(deleteObject); 
    }

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setDeleteConfirm('init');
            }
        }

        document.addEventListener('mousedown', handleOutsideClick);

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [containerRef]);

    useEffect(() => {
        if(delMut.isError){
            setDeleteConfirm('init');
        }
    },[delMut.isError])

    return(
        <>
            {
                delMut.isPending
                ?
                    <Button type="button" variant="danger" size="sm" disabled aria-label="Deleting" title="Deleting">
                        <Spinner animation="border" size="sm" />
                    </Button>
                :
                    deleteConfirm === 'init'
                    ?
                        <Button type="button" variant="danger" size="sm" onClick={_handleInitialClick} aria-label="Delete" title="Delete" {...props}>
                            <FontAwesomeIcon icon={faTrashCan} />
                        </Button>
                    :
                        <Button type="button" variant="danger" size="sm" onClick={_handleConfirmClick} ref={containerRef} aria-label="Click to confirm deletion" title="Click to confirm deletion">
                            <>{confirmText}</>
                        </Button>
            }
        </>
    )
}

export default DeleteButtonMutation;